import { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/autoplay";

import { Navigation, Autoplay } from "swiper";

// Desktop Images
import Banner1 from "../../assets/img/home2/b1.png";
import Banner5 from "../../assets/img/home2/b2.png";
import Banner2 from "../../assets/img/home2/b3.png";
import Banner3 from "../../assets/img/home2/b4.png";
import Banner4 from "../../assets/img/home2/b5.png";

// Mobile Images
// import MobileBanner1 from "../../assets/img/home2/MobileBanner1.jpg";
// import MobileBanner2 from "../../assets/img/home2/MobileBanner2.jpg";
// import MobileBanner3 from "../../assets/img/home2/MobileBannerCorn.jpg";
// import MobileBanner4 from "../../assets/img/home2/MobileBanner4.jpg";
// import MobileBanner5 from "../../assets/img/home2/MobileBanner5.jpg";
import { Link } from "react-router-dom";

const HeroTwo = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkScreenSize(); // Initial check
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const desktopImages = [
    {Banner: Banner1,
    pname: "Super Sunflower Oil",
    bgcolor: "lightyellow",
    pcname: "lightyellow",
    desc: "Shree Gita Refined Super Sunflower Oil is a premium quality cooking oil known for its light texture, neutral flavor, and health benefits. Extracted from sunflower seeds using advanced refining processes, this oil is carefully processed to ensure purity, clarity, and consistent quality. It is a versatile cooking medium that is suitable for various culinary applications, including frying, sautéing, baking, and salad dressings. Rich in polyunsaturated fats and low in saturated fats, Shree Gita Sunflower Oil is considered heart-healthy and is a popular choice among health-conscious consumers. Its light and clean taste make it an ideal choice for cooking a wide range of dishes without overpowering their natural flavors. So what are you waiting for? Go ahead and buy this product online today!",
    }, 
    {Banner: Banner2,
      pname: "Super Mustard Oil",
      bgcolor: "#ffeaea",
      pcname: "#ffeaea",
      desc: "Introducing Shree Gita Super Mustard Oil, a premium cooking oil renowned for its distinctive flavor, nutritional benefits, and versatility in the kitchen. Made from the finest quality mustard seeds and processed using advanced techniques, this oil is ideal for enhancing the taste and aroma of your favorite dishes. Whether you're frying, sauteing, or seasoning, Shree Gita Super Mustard Oil is the perfect choice for adding a touch of tradition and authenticity to your cooking. So what are you waiting for? Go ahead and buy this product online today!",
    }, 
    {Banner: Banner3,
      pname: "Super Corn Oil",
      bgcolor: "#e0ffec",
      pcname: "#e0ffec",
      desc: "Introducing Shree Gita Super Corn Oil — a high-quality, heart-healthy cooking oil trusted for its light texture, neutral flavor, and exceptional health benefits. Made from premium-grade corn kernels and refined through advanced processing techniques, this oil retains essential nutrients while ensuring purity and freshness.Shree Gita Super Corn Oil is rich in plant sterols and polyunsaturated fats, making it an excellent choice for maintaining heart health and managing cholesterol levels. Its high smoke point makes it perfect for deep frying, stir-frying, baking, or even salad dressings — giving your meals a deliciously light touch without overpowering flavors.",
    },
    {Banner: Banner4,
      pname: "Ultra Lite Refined Cotton Seed Oil",
      bgcolor: "#ececec",
      pcname: "#ececec",
      desc: "Introducing Shree Gita Ultra Lite Refined Cotton Seed Oil, a premium cooking oil that combines the goodness of cotton seeds with advanced refining techniques to offer a light, versatile, and healthy option for all your culinary needs. Sourced from the finest cotton seeds and processed with utmost care, this oil is renowned for its neutral flavor, high smoke point, and nutritional benefits, making it an ideal choice for frying, sauting, baking, and salad dressing. So what are you waiting for? Go ahead and buy this product online today!",
    },
    {Banner: Banner5,
      pname: "Super Double Filtered Groundnut Oil",
      bgcolor: "#c6ddff",
      pcname: "#c6ddff",
      desc: "Introducing Shree Gita Super Double Filtered Groundnut Oil, a premium cooking oil renowned for its purity, superior flavor, and numerous health benefits. Sourced from the finest quality groundnuts and processed using advanced double filtration techniques, this oil is ideal for all your culinary needs, from frying to baking and salad dressing. Whether you're a professional chef or a home cook, Shree Gita Super Double Filtered Groundnut Oil is the perfect choice for enhancing the taste and nutritional value of your favorite dishes. So what are you waiting for? Go ahead and buy this product online today!",
    }];
  const mobileImages = desktopImages;

  return (
    <section className="hero-wrapper hero-2">
      <div className="row mb-3">
          <div className="col-xl-12">
              <div className="block-contents text-center">
                  <div className="section-title">
                      <h5>Products</h5>
                      <span>Featured products</span>
                      <h2>What We sell</h2>
                  </div>
              </div>
          </div>
      </div>      
      <div className="row">
        <Swiper
          navigation={true}
          modules={[Navigation, Autoplay]}
          loop
          autoplay={{ delay: 5000, disableOnInteraction: true }}
        >
          {(isMobile ? mobileImages : desktopImages).map((prodData, index) => (
            <SwiperSlide key={index} className="hero-slider-2">
              <div className="single-slide">
                {/* <img src={banner} alt={`Slide ${index + 1}`} className="slide-image" loading="lazy"  style={isMobile ? { height: "100vh" } : {}}/> */}
                <div className="row">
                    <div className="col-md-6">
                        <img src={prodData.Banner} alt={`Slide ${index + 1}`} className="slide-image" loading="lazy"  style={isMobile ? { height: "100vh" } : {height: "500px", objectFit:'fill'}}/>
                    </div>
                    <div className="col-md-6 d-flex flex-column justify-content-center align-items-center text-center" style={{backgroundColor: prodData.bgcolor, height: isMobile ? "100vh" : "500px"}}>
                        <div className="text-start m-5">
                          
                            <h2 className="mb-3" style={{color:'red'}}>{prodData.pname}</h2>
                            {/* <span style={{color:'#7a0202'}}>Hello, this is product</span> */}
                            {/* <h2 className="mb-3" style={{color:'#065506'}}>{prodData.pname}</h2> */}
                            <p>{prodData.desc}</p>
                            <div className="mt-1 d-flex gap-4">
                              <Link className="theme-btn style-3 mt-30" to="/products">View details</Link>
                              <Link className="theme-btn style-4 mt-30" to="/contact">Shop Now</Link>
                            </div>                          
                        </div>
                    </div>
                </div>
                {/* <Link className="theme-btn mt-35" style={{
                  position: "absolute",
                  left:"10%",
                  top: "70%",
                }}>Gold Coin Where Housing</Link> */}
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Styles for Responsiveness */}
        <style jsx>{`
          .single-slide {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .slide-image {
            width: 100%;
            height: auto;
            object-fit: cover;
          }

          @media (max-width: 1024px) {
            .single-slide {
              height: 60vh;
            }
          }

          @media (max-width: 768px) {
            .single-slide {
              height: 100vh;
            }
          }
        `}</style>
      </div>        
    </section>
  );
};

export default HeroTwo;
